<template>
    <div>
        <nav-bar></nav-bar>
        <div class="container">
          <div class="card card-404">
            <div class="card-content">
              <h1 class="h1-404 has-text-centered">
                {{ CONSTANTS.getCopy('NOTFOUND_TITLE') }}
              </h1>
              <p class="title has-text-centered">
                {{ CONSTANTS.getCopy('NOTFOUND_1') }}<br><br>
                {{ CONSTANTS.getCopy('NOTFOUND_2') }}
              </p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue